/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantTagKeyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TenantTagKeyQueryOperator");
    }

    getFixupPrototypeFunction() { return TenantTagKeyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TenantTagKeyQueryOperator>): TenantTagKeyQueryOperator {
        let obj = Object.assign(new TenantTagKeyQueryOperator(), model);
        TenantTagKeyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantTagKeyQueryOperator>): TenantTagKeyQueryOperator {
        if (!model) return null;
        return TenantTagKeyQueryOperator.newInstance(<TenantTagKeyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantTagKeyQueryOperator) {
        if (!obj) return;

        models.TenantTagKeyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantTagKeyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantTagKeyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag keys to include
     */
    tag_keys: Array<string>;

}
